/*=========================================================================================
  File Name: moduleCompanyGetters.js
  Description: Company Module Getters
 ==========================================================================================*/


export default {
  getUserVenue(state){
    return state
  }
}
